import { vModelRadio as _vModelRadio, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-checker default-checker--filter default-checker--radio" }
const _hoisted_2 = { class: "default-checker__checkbox default-checker__checkbox--ma_none" }
const _hoisted_3 = ["value", "checked"]
const _hoisted_4 = { class: "ds-caption ds-caption--color_grey ds-caption--size_sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["gt-checkbox-main gt-checkbox-main--radio", { 'active': $setup.modelValue === $props.value }])
      }, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", _mergeProps({ class: "checker" }, _ctx.$attrs, {
            type: "radio",
            value: $props.value,
            checked: $setup.modelValue === $props.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.modelValue) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.setValue($props.value)))
          }), null, 16, _hoisted_3), [
            [_vModelRadio, $setup.modelValue]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "gt-checkbox-main__label" }, null, -1))
        ])
      ], 2)
    ]),
    _createElementVNode("div", {
      class: "default-checker__description pointer",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.setValue($props.value)), ["prevent"]))
    }, [
      _createElementVNode("p", _hoisted_4, _toDisplayString($props.label), 1)
    ])
  ]))
}